<script lang="ts">
  import { onMount } from "svelte";
  import { register } from "swiper/element/bundle";
  import "swiper/css";
  import { isMobile } from "../../helpers";
  import {
    locationsWithNewWalkins,
    locationsWithSocialLanes,
  } from "../../helpers/BookHelper";
  import { location } from "../../stores/BookingStore";
  import Payment from "../Book/Payment/Payment.svelte";

  // swiper register
  register();

  let selectedLocation: any;
  let locationName: string;

  let slidesPerView: number = isMobile() ? 1.2 : 3;
  let showControls: boolean = true;
  let loop: boolean = true;
  let allowTouchMove: boolean = true;

  location.subscribe((val) => (selectedLocation = val));

  let promotions = [
    {
      title: "Kids Throw",
      subtitle: null,
      price: `<sup class="text-xs font-semibold">Only</sup> $33.99 `,
      descriptionItems: [
        "1.5 hours booking",
        "Any day, any time",
        "Kids age 12 and under",
      ],
      descriptionHtml: ``,
      buttonText: "Book Now",
      buttonUrl: "#reserve-lane",
      image: "/wp-content/themes/badaxe/img/promotions/kids-throw.png",
    },
    {
      title: "Student Walk-ins",
      subtitle: null,
      price: `<sup class="text-xs font-semibold">Only</sup> $19.99`,
      descriptionItems: [
        "45 minute session",
        "Any day, any time",
        "Must present valid student ID",
      ],
      descriptionHtml: ``,
      buttonText: "Book Now",
      buttonUrl: "#reserve-lane",
      image: "/wp-content/themes/badaxe/img/promotions/student-walkins.png",
    },
    {
      title: "On Your Birthday!",
      subtitle: "Get in Free",
      price: null,
      descriptionItems: [
        "Book within 7 days of your birthday",
        "Book an event for 7 or more people",
        "Birthday celebrant gets in FREE",
      ],
      descriptionHtml: ``,
      buttonText: "Book Now",
      buttonUrl: "#reserve-lane",
      image:
        "/wp-content/themes/badaxe/img/promotions/get-free-on-birthday.png",
    },
    {
      title: "Heroes Night",
      subtitle: null,
      price: `<sup class="text-xs font-semibold">Only</sup> $33.99`,
      descriptionItems: [],
      descriptionHtml: `
                <p class="text-sm text-center">Monday - Wednesday</p>
                <p class="text-sm text-center">Bookings Only - 4PM Onwards</p>
                <div class="border-2 border-b-2 border-yellow-400 mt-2 mb-3"></div>
                <p class="text-center text-sm">Veterans - Active Military</p>
                <p class="text-center text-sm">First Responders</p>
                <p class="text-center text-sm">Healthcare Workers - Teachers</p>
            `,
      buttonText: "Book Now",
      buttonUrl: "#reserve-lane",
      image: "/wp-content/themes/badaxe/img/promotions/heroes-night.png",
    },
    {
      title: "Teachers Night",
      subtitle: null,
      price: `<sup class="text-xs font-semibold">Only</sup> $33.99`,
      descriptionItems: [],
      descriptionHtml: `
                <p class="text-sm text-center">Monday - Wednesday</p>
                <p class="text-sm text-center">Bookings Only - 4PM Onwards</p>
                <div class="border-2 border-b-2 border-yellow-400 mt-2 mb-3"></div>
                <p class="text-center text-sm">Teachers - High School Teachers</p>
                <p class="text-center text-sm">Elementary School Teachers - </p>
                <p class="text-center text-sm">Substitute Teachers</p>
            `,
      buttonText: "Book Now",
      buttonUrl: "#reserve-lane",
      image: "/wp-content/themes/badaxe/img/promotions/teachers-night.png",
    },
    {
      title: "Bad Axe Military Rate",
      subtitle: null,
      price: `<sup class="text-xs font-semibold">Only</sup> $33.99`,
      descriptionItems: [],
      descriptionHtml: `
                <p class="text-sm text-center uppercase">Any Day, Any Time</p>
                <p class="text-sm text-center">Veterans - Active Military</p>
                <div class="border-2 border-b-2 border-yellow-400 mt-2 mb-3"></div>
                <p class="text-center text-sm">Veterans and Active military enjoy a</p>
                <p class="text-center text-sm">discounted rate on bookings.</p>
                <p class="text-center text-sm mt-2">Thank you for your service!</p>
            `,
      buttonText: "Book Now",
      buttonUrl: "#reserve-lane",
      image: "/wp-content/themes/badaxe/img/promotions/military-rate.png",
    },
  ];

  $: {
    if (
      selectedLocation.name != null &&
      selectedLocation.name.toLowerCase() == "windsor"
    ) {
      promotions = promotions.map((promotion) => {
        if (promotion.title.toLowerCase() == "kids throw") {
          promotion.descriptionItems = [
            "2 hours booking",
            "Any day, any time",
            "Kids age 12 and under",
          ];
        }
        if (promotion.title.toLowerCase() == "student walk-ins") {
          promotion.descriptionItems = [
            "1 hour session",
            "Any day, any time",
            "Must present valid student ID",
          ];
        }

        return promotion;
      });
    }

    if (
      selectedLocation.name != null &&
      selectedLocation.name.toLowerCase() == "winnipeg"
    ) {
      // remove Kids throw, Teachers night, military rates
      slidesPerView = isMobile() ? 1.2 : 3;
      showControls = false;
      loop = false;
      allowTouchMove = false;
      let promotionsToRemove = [
        "kids throw",
        "teachers night",
        "bad axe military rate",
      ];
      promotions = promotions
        .filter((promotion) => {
          return !promotionsToRemove.includes(promotion.title.toLowerCase());
        })
        .map((promotion) => {
          if (promotion.title.toLowerCase() == "on your birthday!") {
            promotion.subtitle = "";
            promotion.title = "Birthday Celebrant Gets Free Add-ons!";
            promotion.descriptionItems = [
              "Book within 7 days of your birthday",
              "Birthday* celebrant gets FREE big axe & knife throwing add-ons!",
            ];
          }

          if (promotion.title.toLowerCase() == "heroes night") {
            promotion.descriptionHtml = `
                        <p class="text-sm text-center">Sunday - Thursday</p>
                        <p class="text-sm text-center">Bookings Only - 4PM Onwards</p>
                        <div class="border-2 border-b-2 border-yellow-400 mt-2 mb-3"></div>
                        <p class="text-center text-sm">Veterans - Active Military</p>
                        <p class="text-center text-sm">First Responders</p>
                        <p class="text-center text-sm">Healthcare Workers - Teachers</p>
                    `;
            promotion.title = "Heroes Nights";
            promotion.price =
              "<span class='block'>$135 / 1 lane or $250 / 2 lanes</span>";
          }

          return promotion;
        });
    }

    if (
      selectedLocation.name != null &&
      locationsWithSocialLanes.includes(selectedLocation.name.toLowerCase())
    ) {
      promotions = promotions.map((promotion) => {
        if (promotion.title.toLowerCase() == "student walk-ins") {
          promotion.price = `<sup class="text-xs font-semibold">Only</sup> $27.75`;
          promotion.buttonUrl = "https://badaxethrowing.com/walkins";
          promotion.descriptionItems = [
            "1 hour session",
            "Any day, any time",
            "Must present valid student ID",
          ];
        }

        return promotion;
      });
    }
    if (
      selectedLocation.name != null &&
      locationsWithNewWalkins.includes(selectedLocation.name.toLowerCase())
    ) {
      promotions = promotions.map((promotion) => {
        if (promotion.title.toLowerCase() == "student walk-ins") {
          promotion.price = `<sup class="text-xs font-semibold">Only</sup> $27.75`;
          promotion.descriptionItems = [
            "1 hour session",
            "Any day, any time",
            "Must present valid student ID",
          ];
        }

        return promotion;
      });
    }

    // if (
    //     selectedLocation.name != null &&
    //     selectedLocation.name.toLowerCase() == "alexandria"
    // ) {
    //     promotions = promotions.map((promotion) => {
    //         if (promotion.title.toLowerCase() == "student walk-ins") {
    //             promotion.price = `<sup class="text-xs font-semibold">Only</sup> $27.75`;
    //             promotion.descriptionItems = [
    //                 "1 hour session",
    //                 "Any day, any time",
    //                 "Must present valid student ID",
    //             ];
    //         }
    //
    //         return promotion;
    //     });
    // }

    // if (
    //     selectedLocation.name != null &&
    //     selectedLocation.name.toLowerCase() == "charlotte"
    // ) {
    //     promotions = promotions.map((promotion) => {
    //         if (promotion.title.toLowerCase() == "student walk-ins") {
    //             promotion.price = `<sup class="text-xs font-semibold">Only</sup> $27.75`;
    //             promotion.descriptionItems = [
    //                 "1 hour session",
    //                 "Any day, any time",
    //                 "Must present valid student ID",
    //             ];
    //         }
    //         return promotion;
    //     });
    // }

    // if (
    //     selectedLocation.name != null &&
    //     selectedLocation.name.toLowerCase() == "colorado springs"
    // ) {
    //     promotions = promotions.map((promotion) => {
    //         if (promotion.title.toLowerCase() == "student walk-ins") {
    //             promotion.price = `<sup class="text-xs font-semibold">Only</sup> $27.75`;
    //             promotion.descriptionItems = [
    //                 "1 hour session",
    //                 "Any day, any time",
    //                 "Must present valid student ID",
    //             ];
    //         }
    //         return promotion;
    //     });
    // }
  }

  onMount(async () => {
    // const swiperEl = document.querySelector("swiper-container");
    const swiperEl = document.querySelector("#swiper-promotions");
    const prevBtn = document.querySelector("#prev-btn-promotions");
    const nextBtn = document.querySelector("#next-btn-promotions");

    prevBtn?.addEventListener("click", () => {
      swiperEl?.swiper.slidePrev();
      swiperEl?.swiper.autoplay.stop();
    });
    nextBtn?.addEventListener("click", () => {
      swiperEl?.swiper.slideNext();
      swiperEl?.swiper.autoplay.stop();
    });

    locationName = selectedLocation.name != null ? selectedLocation.name : null;
  });
</script>

<div class="mt-14 mb-12 px-0 sm:px-0">
  <h3
    class="uppercase font-bold text-3xl text-center w-full flex flex-row items-center justify-center mb-6"
  >
    <span class="down-arrow"></span>
    <span class="mx-8">Weekly Specials</span>
    <span class="down-arrow"></span>
  </h3>
  <div class="gap-3 sm:gap-3 px-0 sm:px-0">
    <swiper-container
      id="swiper-promotions"
      slides-per-view={`${slidesPerView}`}
      loop={`${loop}`}
      space-between="30"
      autoplay-delay="4000"
      allow-touch-move={`${allowTouchMove}`}
    >
      {#each promotions as promotion}
        <swiper-slide
          class="h-100 sm:h-100 border-2 border-gray-400 rounded-lg relative"
        >
          <img
            src={promotion.image}
            alt={promotion.title ?? ""}
            class="w-full h-28 sm:h-36 object-cover bg-white"
          />
          <div class="px-2 py-2 sm:px-4 sm:py-4">
            {#if promotion.subtitle != null}
              <p
                class="text-brand uppercase text-base text-center font-semibold font-helveticaneue"
              >
                {promotion.subtitle}
              </p>
            {/if}
            <h4
              class="uppercase text-black text-lg sm:text-xl leading-5 text-center font-semibold font-helveticaneue"
            >
              {promotion.title}
            </h4>
            {#if promotion.price != null}
              <p
                class="text-brand text-center text-xl font-semibold font-helveticaneue"
              >
                {@html promotion.price}
              </p>
            {/if}
            {#if promotion.descriptionItems.length > 0 && promotion.descriptionItems}
              <ul class="mt-4">
                {#each promotion.descriptionItems as item}
                  <li class="relative pl-6 font-helveticaneue">
                    <div
                      class="absolute left-0 top-0 flex justify-center items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="red"
                        class="h-5 w-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                    {item}
                  </li>
                {/each}
              </ul>
            {/if}
            {#if promotion.descriptionHtml != ""}
              <div class="mt-4 font-helveticaneue">
                {@html promotion.descriptionHtml}
              </div>
            {/if}
            <a
              href={promotion.buttonUrl}
              class="bg-brand hover:bg-red-700 uppercase text-white block text-sm w-3/4 sm:w-64 text-center rounded-full px-2 pt-2 pb-2 absolute bottom-4 left-1/2 -translate-x-1/2 transform transition ease-in-out delay-75 font-helveticaneue font-semibold"
              >{promotion.buttonText}</a
            >
          </div>
          <!-- </div> -->
        </swiper-slide>
      {/each}
    </swiper-container>
    {#if showControls}
      <div class="flex flex-row items-center justify-center mt-8">
        <button
          id="prev-btn-promotions"
          class="border-2 border-black rounded-full h-8 w-8 flex items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-6 w-6 text-black"
            ><path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            ></path></svg
          >
        </button>
        <div class="mx-12 text-center w-48 text-xl">More Promotions</div>
        <button
          id="next-btn-promotions"
          class="border-2 border-black rounded-full h-8 w-8 flex items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-6 w-6 text-black"
            ><path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            ></path></svg
          >
        </button>
      </div>
    {/if}
  </div>
</div>

<style>
  .down-arrow {
    display: inline-block; /* Display as inline element */
    width: 0; /* Set initial width to 0 */
    height: 0; /* Set initial height to 0 */
    border-left: 7px solid transparent; /* Left border for first point */
    border-right: 7px solid transparent; /* Right border for first point */
    border-top: 12px solid #ee2c2c; /* Bottom border for first point (adjust color) */
    border-bottom: 0;
  }

  .down-arrow::after {
    content: ""; /* Empty content for pseudo-element */
    display: block; /* Display as block for stacking */
    width: 0; /* Set initial width to 0 */
    height: 0; /* Set initial height to 0 */
    border-left: 7px solid transparent; /* Left border for third point */
    border-right: 7px solid transparent; /* Right border for third point */
    border-top: 12px solid #ee2c2c; /* Bottom border for third point (adjust color) */
    position: relative; /* Enable relative positioning */
    top: -25px; /* Offset upwards further for stacking */
    left: -7px; /* Offset slightly left for alignment */
  }
</style>
